import { createChatStore, type ChatStore, type ChatStoreHook } from '../../chat/core';

/**
 * Chat state for one surface — the shared chat store (`src/chat/core`).
 *
 * Each docked chat keeps its own thread, messages and turn, so a dashboard
 * conversation and a monitor conversation cannot bleed into one another.
 */
export type SurfaceChatStore = ChatStore;

export function createSurfaceChatStore(initialTitle: string): ChatStoreHook {
  return createChatStore(initialTitle);
}
